import { render } from "./CloseOrderModal.vue?vue&type=template&id=3a40983f&scoped=true"
import script from "./CloseOrderModal.vue?vue&type=script&lang=js"
export * from "./CloseOrderModal.vue?vue&type=script&lang=js"

import "./CloseOrderModal.vue?vue&type=style&index=0&id=3a40983f&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a40983f"]])

export default __exports__